import he from 'he';
import fp from 'lodash/fp';
import React from 'react';
import Spinner from 'react-spinkit';

export const DataTable = ({ columns, rows, addTasks, className, isLoading = false }) => (
  <table id='data-table' className={className}>
    <thead>
      <tr>
        {
          fp.map(({ columnName, display }) =>
            <td key={columnName}>{
              display(addTasks, rows)
            }</td>
          )(columns)
        }
      </tr>
    </thead>
    <tbody>
      {
        isLoading
          ? <Spinner name='circle' className='spinner' fadeIn='none' />
          : fp.map((row) => (
              <tr key={row.id}>
                {
                  fp.map(({ columnName }) => (
                    <td key={`cell-${columnName}-${row.id}`}>
                      {typeof (fp.get(columnName)(row)) === 'string' ? he.decode(fp.get(columnName)(row)) : fp.get(columnName)(row)}
                    </td>
                  ))(columns)
                }
              </tr>
            ))(rows)
      }
    </tbody>
  </table>
)


// WEBPACK FOOTER //
// ./src/containers/pages/admin-portal/user-portal/data-table.js